/**
 * @generated SignedSource<<e4bb75926b854df628f82a3307f01220>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EcommerceCustomizationStrategy = "CUSTOMIZER_BUNDLE" | "DUPLICATION" | "NO_DUPLICATION" | "OPTIMISTIC_DUPLICATION" | "SHOPIFY_CART_TRANSFORM" | "SHOPIFY_CART_TRANSFORM_PLUS";
export type productListShopifyCustomizationStrategyQuery$variables = Record<PropertyKey, never>;
export type productListShopifyCustomizationStrategyQuery$data = {
  readonly ecommerceSettingsAdditionalDataForEcommercePlatform: ReadonlyArray<{
    readonly customizationStrategy: EcommerceCustomizationStrategy;
  }>;
};
export type productListShopifyCustomizationStrategyQuery = {
  response: productListShopifyCustomizationStrategyQuery$data;
  variables: productListShopifyCustomizationStrategyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "ecommerce",
    "value": "SHOPIFY"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customizationStrategy",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "productListShopifyCustomizationStrategyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "EcommerceSettingsAdditionalData",
        "kind": "LinkedField",
        "name": "ecommerceSettingsAdditionalDataForEcommercePlatform",
        "plural": true,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": "ecommerceSettingsAdditionalDataForEcommercePlatform(ecommerce:\"SHOPIFY\")"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "productListShopifyCustomizationStrategyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "EcommerceSettingsAdditionalData",
        "kind": "LinkedField",
        "name": "ecommerceSettingsAdditionalDataForEcommercePlatform",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "ecommerceSettingsAdditionalDataForEcommercePlatform(ecommerce:\"SHOPIFY\")"
      }
    ]
  },
  "params": {
    "cacheID": "b8d276575de19eb881ca84178959115f",
    "id": null,
    "metadata": {},
    "name": "productListShopifyCustomizationStrategyQuery",
    "operationKind": "query",
    "text": "query productListShopifyCustomizationStrategyQuery {\n  ecommerceSettingsAdditionalDataForEcommercePlatform(ecommerce: SHOPIFY) {\n    customizationStrategy\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b14bd6dce77f3feb1ba7c4bc2c6ae22e";

export default node;
